import StationTypeModel from './../models/StationTypeModel';
import BaseStore from './BaseStore';

export default class StationTypeStore extends BaseStore {
  constructor(transportLayer) {
    super(StationTypeModel, transportLayer);
  }

  getTypeHierarchy() {
    let items = Object.assign([], this.items.map(item => ({
      id: item.id,
      name: item.name,
      full_type: this.getFullType(item),
    })));
    return items.filter(item => item.full_type === item.name || !items.find(i => item.full_type !== i.full_type && i.full_type.indexOf(item.full_type) > -1))
  }

  getFullType(item, i = 0) {
    let parent = this.findById(item.parent_id);
    console.log(parent,"parent");
    if (!parent) {
      return item.name
    } else {
      return `${item.name}, ${i > 10 ? '...' : this.getFullType(parent, i + 1)}`
    }
  }

};


// WEBPACK FOOTER //
// ./src/stores/StationTypeStore.js